import classNames from 'classnames';
import styles from './index.module.scss';
import { ReactComponent as RefreshIcon } from '../../assets/icons/patientProfileIcons/refreshIcon.svg';
import { ReactComponent as CheckIcon } from '../../assets/icons/patientProfileIcons/checkIcon.svg';
import { observer } from 'mobx-react-lite';
import { find, isEmpty } from 'lodash';
import { FunctionComponent, SVGProps } from 'react';
import i18next from 'i18next';

export enum updatingStatusEnum {
  initial = 'initial',
  inProgress = 'inProgress',
  done = 'done',
  failed = 'failed',
}

interface IStatusOption {
  text: string;
  status: updatingStatusEnum;
  Icon?: FunctionComponent<SVGProps<SVGSVGElement>>;
  iconClassName?: string;
}
export const updatingStatusOptions: {
  [key: string]: IStatusOption;
} = {
  [updatingStatusEnum.inProgress]: {
    text: `${i18next.t('profile.status.saving')}...`,
    Icon: RefreshIcon,
    status: updatingStatusEnum.inProgress,
    iconClassName: 'animate-spin',
  },
  [updatingStatusEnum.done]: {
    text: i18next.t('profile.status.changesSaved'),
    Icon: CheckIcon,
    status: updatingStatusEnum.done,
  },
};
const SaveStatusChips = ({ updatingStatus }: { updatingStatus: updatingStatusEnum }) => {
  const updatingStatusOption =
    find(updatingStatusOptions, (option) => option.status === updatingStatus) ??
    ({} as IStatusOption);

  if (isEmpty(updatingStatusOption)) {
    return null;
  }
  const { text, Icon, status, iconClassName } = updatingStatusOption;

  return (
    <div
      className={classNames(
        'flex items-center px-4 py-2 font-semibold text-base',
        styles.root,
        status && styles[status],
      )}
    >
      {Icon ? <Icon className={iconClassName} /> : null}
      {text}
    </div>
  );
};

export default observer(SaveStatusChips);
